<template>
    <div class="item-name">
        {{name_object.name}}
        <input type="text" class="name_input" 
            v-model.lazy="name_object.value" 
            placeholder="名称定义" autofocus onfocus="this.select()"
        />
        <bay-item-edit 
            v-if="editable" 
            class="edit-show" 
            :index="index"
            v-on="$listeners"
        ></bay-item-edit>
    </div>
    
</template>

<script>
import BayItemEdit from './BayItemEdit.vue'
export default {
   name:'BayItemName',
   props:{
       name_object:Object,
       editable:Boolean,
       index:Number,
   },
   components:{
       BayItemEdit,
   }
}
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/var.styl';
.item-name
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:20px;
    border-bottom:1.5px solid darkgray;
    box-sizing:border-box;
    height:$item_name_height;
    position:relative;
    background-color:white;//$bay_item_name_color;
    color:red;
    //不需要hover显示，直接显示
    div:nth-last-child(1)
        width:20px;
    /* 
    &:hover
        div:nth-last-child(1)
        width:20px;   
    */



    .name_input
        clear_default_style();
        display:inline;
        width:60px;
        text-align:center;
        color:red;
        margin-left:10px;
        font-size:20px;
        font-family:inherit;
        border-bottom:1px solid darkgray;
    




</style>
